var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-card', {
    staticClass: "shadow-sm"
  }, [_c('b-card-title', {
    staticClass: "mb-2 px-6 pt-6"
  }, [_c('div', [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "exclamation-circle-fill",
      "variant": "primary"
    }
  }), _c('span', [_vm._v("Inadimplência")])], 1), _c('FiltroPeriodo', {
    staticClass: "mt-4",
    attrs: {
      "value": _vm.periodo,
      "default-label": "Hoje",
      "auto-apply-on-mount": !_vm.ignoreInitialApply
    },
    on: {
      "apply": _vm.onApplyPeriodo
    }
  })], 1), _c('b-card-body', {
    staticClass: "pl-6 pb-4 pt-3 d-flex align-items-end mb-2"
  }, [_vm.loading ? [_c('b-skeleton', {
    staticClass: "mr-3",
    attrs: {
      "width": "40%",
      "height": "36px"
    }
  }), _c('b-skeleton', {
    attrs: {
      "width": "80px",
      "height": "24px"
    }
  })] : [_c('h2', {
    staticClass: "display-4 text-danger mb-0 font-weight-bold",
    staticStyle: {
      "line-height": "1.6rem"
    }
  }, [_vm._v(" " + _vm._s(_vm.toCurrency(_vm.inadimplencia.valor)) + " ")]), _c('span', {
    staticClass: "ml-4 badge",
    class: _vm.percentualBadgeClass
  }, [_vm._v(" " + _vm._s(_vm.formatPercent(_vm.inadimplencia.percentual)) + " ")])]], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };